import HowToCards from './HowToCards';

export default HowToCards;
